"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _awaitAsyncGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/awaitAsyncGenerator"));

var _wrapAsyncGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapAsyncGenerator"));

var _asyncIterator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncIterator"));

var _jsonldContextParser = require("jsonld-context-parser");

var _promiseUtils = require("./promiseUtils");
/**
 * Queries for all compacted predicates of a path subject
 */


var PropertiesHandler =
/*#__PURE__*/
function () {
  function PropertiesHandler() {
    _classCallCheck(this, PropertiesHandler);
  }

  _createClass(PropertiesHandler, [{
    key: "handle",
    value: function handle(pathData, path) {
      return (0, _promiseUtils.toIterablePromise)(this._handle(pathData, path));
    }
  }, {
    key: "_handle",
    value: function _handle(pathData, path) {
      return (0, _wrapAsyncGenerator2.default)(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var context, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, predicate;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _awaitAsyncGenerator2.default)(pathData.settings.parsedContext);

              case 2:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 5;
                  break;
                }

                _context.t0 = {};

              case 5:
                context = _context.t0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context.prev = 8;
                _iterator = (0, _asyncIterator2.default)(path.predicates);

              case 10:
                _context.next = 12;
                return (0, _awaitAsyncGenerator2.default)(_iterator.next());

              case 12:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 16;
                return (0, _awaitAsyncGenerator2.default)(_step.value);

              case 16:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 31;
                  break;
                }

                predicate = _value;
                _context.t1 = _jsonldContextParser.ContextParser;
                _context.t2 = "";
                _context.next = 23;
                return (0, _awaitAsyncGenerator2.default)(predicate);

              case 23:
                _context.t3 = _context.sent;
                _context.t4 = _context.t2.concat.call(_context.t2, _context.t3);
                _context.t5 = context;
                _context.next = 28;
                return _context.t1.compactIri.call(_context.t1, _context.t4, _context.t5, true);

              case 28:
                _iteratorNormalCompletion = true;
                _context.next = 10;
                break;

              case 31:
                _context.next = 37;
                break;

              case 33:
                _context.prev = 33;
                _context.t6 = _context["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context.t6;

              case 37:
                _context.prev = 37;
                _context.prev = 38;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context.next = 42;
                  break;
                }

                _context.next = 42;
                return (0, _awaitAsyncGenerator2.default)(_iterator.return());

              case 42:
                _context.prev = 42;

                if (!_didIteratorError) {
                  _context.next = 45;
                  break;
                }

                throw _iteratorError;

              case 45:
                return _context.finish(42);

              case 46:
                return _context.finish(37);

              case 47:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 33, 37, 47], [38,, 42, 46]]);
      }))();
    }
  }]);

  return PropertiesHandler;
}();

exports.default = PropertiesHandler;